document.addEventListener('DOMContentLoaded', () => {
    
    const topbar = document.querySelector('.js-topbar');
    
    const action = function() {
        let scroll_pos = window.pageYOffset || window.scrollY;
        scroll_pos > topbar.clientHeight ? document.documentElement.classList.add('is-narrow') : document.documentElement.classList.remove('is-narrow');
    }

    action();
    topbar ? window.addEventListener('scroll', action) : false;

}, false);
